import * as actionTypes from "../actions/actionTypes";

const initialState = {
    listings: null,
    count: null,
    pages: null,
    currentPage: null,
    loading: false,
    error: false,
    errorMessage: null,
    errorCode: null,
};

const loadListingsStart = (state, action) => {
    return {
        ...state,
        loading: true,
        error: false,
    };
};

const loadListingsSuccess = (state, action) => {
    let newListings;
    if (state.listings === null) {
        newListings = [];
    } else {
        newListings = [...state.listings];
    }
    newListings[action.page] = action.listings;
    return {
        ...state,
        listings: newListings,
        count: action.listingsCount,
        pages: action.pagesCount,
        currentPage: action.page,
        loading: false,
        error: false,
    };
};

const loadListingsFail = (state, action) => {
    return {
        ...state,
        error: true,
        errorMessage: action.errorMessage,
        errorCode: action.errorCode,
        loading: false,
    };
};

const changeActivePage = (state, action) => {
    return {
        ...state,
        currentPage: action.page,
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_LISTINGS_START:
            return loadListingsStart(state, action);
        case actionTypes.LOAD_LISTINGS_SUCCESS:
            return loadListingsSuccess(state, action);
        case actionTypes.LOAD_LISTINGS_FAIL:
            return loadListingsFail(state, action);
        case actionTypes.CHANGE_ACTIVE_PAGE:
            return changeActivePage(state, action);
        default:
            return state;
    }
};

export default reducer;
